import { Link } from "react-router";
import { cn } from "@/utils/css";
import { useAreFeaturesUnlocked } from "@/auth/roles";

export const LockedLink = ({ to, onClick, className, children }) => {
    const isLocked = !useAreFeaturesUnlocked();

    if (isLocked) {
        return <span className={className}>{children}</span>;
    }

    return (
        <Link to={to} onClick={onClick} className={className}>
            {children}
        </Link>
    );
};
